import { css } from "@emotion/react";

export const globalStyles = css`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    /* Couleurs principales */
    --color-primary: #C0392B;
    --color-primary-light: #E74C3C;
    --color-gold: #F1C40F;
    --color-gold-dark: #D4AC0D;
    --color-navy: #1A2A4A;
    --color-navy-mid: #243860;

    /* Neutres */
    --color-bg: #FAF8F4;
    --color-bg-warm: #F2EDE4;
    --color-text: #2C2C2C;
    --color-border: #E8E4DD;
    --color-white: #FFFFFF;

    /* Fonctionnelles */
    --color-success: #27AE60;
    --color-error: #E74C3C;
    --color-info: #3498DB;
    --color-warning: #F39C12;

    /* Typographie */
    --font-display: 'Bebas Neue', cursive;
    --font-heading: 'Nunito', sans-serif;
    --font-body: 'Lato', sans-serif;

    --text-xs: 11px;
    --text-sm: 13px;
    --text-base: 15px;
    --text-lg: 18px;
    --text-xl: 24px;
    --text-2xl: 32px;
    --text-3xl: 48px;
    --text-4xl: 72px;

    /* Border radius */
    --radius-sm: 6px;
    --radius-md: 10px;
    --radius-lg: 14px;
    --radius-xl: 20px;
    --radius-full: 9999px;

    /* Compat mappings */
    --text-primary: #2C2C2C;
    --text-secondary: #6B7280;
    --text-accent: #C0392B;
    --container-bg: #FFFFFF;
    --input-border: #E8E4DD;
    --input-border-focus: #C0392B;
    --input-bg: #FFFFFF;
    --error-text: #E74C3C;
    --error-bg: rgba(231, 76, 60, 0.1);
    --success-text: #27AE60;
    --success-bg: rgba(39, 174, 96, 0.1);
    --dropdown-bg: #FFFFFF;
    --dropdown-hover: #F2EDE4;
    --selected-word-bg: rgba(192, 57, 43, 0.1);
    --shadow-light: rgba(0, 0, 0, 0.06);
    --shadow-medium: rgba(0, 0, 0, 0.08);
    --shadow-dark: rgba(0, 0, 0, 0.15);
  }

  body {
    margin: 0;
    font-family: var(--font-body);
    font-weight: 400;
    font-size: var(--text-base);
    background: var(--color-bg);
    color: var(--color-text);
    min-height: 100vh;
  }

  #root {
    width: 100%;
    min-height: 100vh;
    display: flex;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
